import { connect } from "react-redux";

import Actions from "../../Actions/Creators";
import { destroy } from "redux-form";

import Phi from "../../Phi/Phi";
import StudentProfile from "./Component/StudentProfile";

const getSelectedChild = (state) =>
  state?.child?.childList &&
  state?.child?.childList?.length &&
  state?.child?.childList[state?.child?.selectedChild || 0];

const mapStateToProps = (state, ownProps) => {
  const userRole = Phi.User.roles(); // Fetch user roles using Phi library

  return {
    child: getSelectedChild(state),
    organizationId: JSON.parse(Phi.Storage.getItem("organization"))
      ? JSON.parse(Phi.Storage.getItem("organization"))[0].org_id
      : null,
    studentHeader: state.student.studentHeader,
    assessmentStatus: state.student.assessmentStatus,
    studentList: state.student.studentList,
    episodeList: state.student.episodeList,
    newStudent: JSON?.parse(sessionStorage?.getItem("student")),
    medicaldata: state.student.medicaldata,
    childList: state?.child?.childList,

    currentProgram: state.organization.currentProgram,

    programs: state.organization.programs,
    startNodeMap: JSON?.parse(sessionStorage?.getItem("startNodemap")),
    history: state.organization.history,
    vaccines: state.student.vaccineList,
    roleType: userRole && userRole.length && userRole[0].role_type_id, // Assign roleType based on user roles
    selectedEventTrackingId: state,
    selectedBillingId: sessionStorage.getItem("selectedBillingId"),
    programHistory: state.organization.history,
  };
};

const mapDispatchToProps = (dispatch) => ({
  fetchStudentList: (payload) => dispatch(Actions.fetchStudentList(payload)),
  fetchEpisodeSearch: (header) =>
    dispatch(Actions.fetchStudentEpisodeSearch(header)),
  fetchStudentProfileSearch: (header) =>
    dispatch(Actions.fetchStudentProfileSearch(header)),
  fetchStudentAssessmentStatus: (header) =>
    dispatch(Actions.fetchStudentAssessmentStatus(header)),
  fetchStudentSearch: (header) =>
    dispatch(Actions.fetchClinicStudentSearch(header)),
  fetchEpisodeStats: (inOrganizationId) =>
    dispatch(Actions.fetchClinicEpisodeStats(inOrganizationId)),

  changeReportInReducer: (billingId) =>
    dispatch(Actions.changeReportInReducer(billingId)),
  fetchNurseMeta: () => dispatch(Actions.fetchNurseMeta()),
  setSelectedStudent: (payload) =>
    dispatch(Actions.setSelectedStudent(payload)),

  fetchVaccination: () => dispatch(Actions.fetchVaccination()),
  getProgramByOrganization: (organization_id) =>
    dispatch(Actions.getProgramByOrganization(organization_id)),

  saveVaccination: (payload) =>
    dispatch(
      Actions.updateUser(payload, { action: Actions.responseUpdateChildUser }),
    ),
  fetchChildList: (userId) => dispatch(Actions.fetchChildList({ userId })),
  getReport: (reportType, config) =>
    dispatch(Actions.getReport(reportType, config)),

  initializeForm: (data) => dispatch(Actions.initializeForm(data)),
  postStudentEpisodeInfo: (studentId, customJson, episodeType) =>
    dispatch(
      Actions.postStudentEpisodeInfo(studentId, customJson, episodeType),
    ),

  //previous

  fetchCustomStudentList: (payload, hideLoader) =>
    dispatch(Actions.fetchCustomStudentList(payload, hideLoader)),
  getStudentReport: (reportType, config) =>
    dispatch(Actions.getStudentReport(reportType, config)),
  setLoader: () => dispatch(Actions.setLoader()),
  unsetLoader: () => dispatch(Actions.unsetLoader()),
  setSelectedChild: (index) => dispatch(Actions.selectChild(index)),
  clearForm: () => dispatch(destroy("customForm")),

  // fetchEpisodeSearch:(()=>buildHeader(newStudentEpisodeHeader, episodeHeader()))
});

export default connect(mapStateToProps, mapDispatchToProps)(StudentProfile);
